import { render, staticRenderFns } from "./SignupRegion.vue?vue&type=template&id=1bf6edb5&scoped=true&"
import script from "./SignupRegion.vue?vue&type=script&lang=js&"
export * from "./SignupRegion.vue?vue&type=script&lang=js&"
import style0 from "./SignupRegion.vue?vue&type=style&index=0&id=1bf6edb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6edb5",
  null
  
)

export default component.exports